import { createContext } from 'react'

/** True while the enclosing EditorToolbar is in its compact (icon-only) stage.
 *  Lets a control that renders its own label (ModeToggle) surface that label as
 *  a hover hint once it is hidden. See EditorToolbar `compactLabels`. */
export const ToolbarCompactContext = createContext(false)
